L.Filter.IN = L.Filter.extend({
    append: function (name, val) {
        let eqElement = L.XmlUtil.createElementNS('ogc:PropertyIsEqualTo');
        let functionElement = L.XmlUtil.createElementNS('ogc:Function', {name: 'in'}, {});
        let nameElement = L.XmlUtil.createElementNS('ogc:PropertyName', {}, {value: name});
        let trueElement = L.XmlUtil.createElementNS('ogc:Literal', {}, {value: 'true'});
        functionElement.appendChild(nameElement);

        for (let idx in val) {
            functionElement.appendChild(L.XmlUtil.createElementNS('ogc:Literal', {}, {value: val[idx]}));
        }

        eqElement.appendChild(functionElement);
        eqElement.appendChild(trueElement);
        this.filter.appendChild(eqElement);
        return this;
    }
});



// WEBPACK FOOTER //
// ./src/components/WFSTFilterIn.js